import { NOT_AVAILABLE_MESSAGE } from "@/store/prohor/prohorLine1";

export const PROHOR_QUESTION_POOL = [
    {
        id: "assign-access-manage",
        priority: 20,
        matchAll: [
            ["назнач", "доступ"],
            ["как", "назнач", "доступ"],
            ["выдать", "доступ"],
            ["управлен", "доступ"],
            ["окно", "доступ"],
            ["как", "выдать", "доступ"],
            ["как", "открыть", "доступ"],
            ["назнач", "доступ", "сотрудник"],
            ["назнач", "доступ", "групп"],
            ["выдать", "прохожден"],
            ["выдать", "квот", "сотрудник"],
            ["назнач", "квот", "сотрудник"],
            ["массов", "доступ"],
            ["тип", "отчет", "выдать"],
        ],
        matchRegex: [
            /^как\s+назначить\s+доступ/,
            /^назначить\s+доступ/,
            /^как\s+назначить\s+доступы/,
        ],
        roles: {
            hrMain: {
                text:
                    "Назначение доступов (тесты, курсы, тренажёры):\n\n" +
                    "1) «Оценка» или обзор группы — отметьте сотрудников чекбоксами.\n" +
                    "2) Нажмите «Управление доступами».\n" +
                    "3) Выберите тип отчёта или продукт (тест / курс / тренажёр).\n" +
                    "4) При нехватке квот — «Заказать доступы» в том же окне или через «Каталог».\n\n" +
                    "Повторно тест можно выдать только если нет незавершённого прохождения. " +
                    "После начала теста квоту нельзя отозвать.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Группы", route: "/groups" },
                    { label: "Каталог", route: "/catalog" },
                ],
            },
            hrSub: {
                text:
                    "В своих группах: обзор группы → выберите сотрудников → «Управление доступами» → " +
                    "тип отчёта или продукт. Массово — через «Оценку» с фильтром по группе. " +
                    "Закупку квот оформляет главный HR.",
                actions: [
                    { label: "Группы", route: "/groups" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            staff: {
                text:
                    "Доступы на тесты, курсы и тренажёры назначает HR/руководитель. " +
                    "Когда назначат — увидите карточки в «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "issue-test-general",
        priority: 20,
        matchAll: [
            ["как", "выдать", "тест"],
            ["выдать", "тест"],
            ["как", "выдать", "тестирован"],
            ["выдать", "тестирован"],
            ["как", "назнач", "тест"],
            ["как", "запуст", "тест"],
            ["как", "провест", "тест"],
            ["как", "отправ", "тест"],
            ["назнач", "тестирован"],
            ["запуст", "тестирован"],
            ["провест", "тестирован"],
            ["отправ", "тест"],
            ["выдать", "отчет", "тип"],
            ["как", "выдать", "отчет"],
        ],
        matchRegex: [/^как\s+выдать\s+тест/, /^выдать\s+тест/],
        roles: {
            hrMain: {
                text:
                    "Как выдать тестирование:\n\n" +
                    "1) Убедитесь, что есть квоты (иначе «Каталог» → заказ).\n" +
                    "2) «Оценка» или «Группы» → обзор группы.\n" +
                    "3) Отметьте сотрудников → «Управление доступами».\n" +
                    "4) Выберите тип отчёта (стандартный, управленческий, экспертный).\n" +
                    "5) При необходимости включите видимость отчёта для сотрудника.\n\n" +
                    "Сотрудник должен завершить тест в течение 24 часов после начала.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            hrSub: {
                text:
                    "«Оценка» или обзор вашей группы → сотрудники → «Управление доступами» → тип отчёта. " +
                    "Квоты закупает главный HR.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "receive-test",
        priority: 19,
        matchAll: [
            ["как", "получ", "тест"],
            ["получ", "тест"],
            ["где", "взять", "тест"],
            ["как", "достать", "тест"],
        ],
        matchRegex: [/^как\s+получить\s+тест/],
        roles: {
            hrMain: {
                text:
                    "Тест для сотрудника выдаёт HR: «Оценка» или группа → «Управление доступами» → тип отчёта. " +
                    "Сначала нужны квоты — закупите в «Каталоге», если их нет.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Каталог", route: "/catalog" },
                ],
            },
            hrSub: {
                text:
                    "Выдайте тест в «Оценке» или в обзоре группы через «Управление доступами». " +
                    "Квоты закупает главный HR.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            staff: {
                text:
                    "Тест назначает HR/руководитель. Когда вам выдадут доступ — карточка появится в «Моё развитие», " +
                    "оттуда можно начать прохождение.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "receive-course",
        priority: 19,
        matchAll: [
            ["как", "получ", "курс"],
            ["получ", "курс"],
            ["где", "взять", "курс"],
            ["как", "достать", "курс"],
        ],
        matchRegex: [/^как\s+получить\s+курс/],
        roles: {
            hrMain: {
                text:
                    "Курс выдаётся через «Развитие» или обзор группы → «Управление доступами». " +
                    "Квоты на курсы — в «Каталоге».",
                actions: [
                    { label: "Развитие", route: "/courses" },
                    { label: "Каталог", route: "/catalog" },
                ],
            },
            hrSub: {
                text: "Назначение курса — в своих группах или в «Развитие».",
                actions: [
                    { label: "Развитие", route: "/courses" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            staff: {
                text:
                    "Курс назначает HR. После назначения откройте «Моё развитие» → «Пройти» (ссылка на LMS).",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "receive-access",
        priority: 19,
        matchAll: [
            ["как", "получ", "доступ"],
            ["получ", "доступ"],
            ["где", "взять", "доступ"],
            ["как", "достать", "доступ"],
        ],
        matchRegex: [/^как\s+получить\s+доступ/],
        roles: {
            hrMain: {
                text:
                    "Доступы (тесты, курсы, тренажёры): закупите квоты в «Каталоге», затем назначьте через " +
                    "«Управление доступами» в «Оценке» или в группе.",
                actions: [
                    { label: "Каталог", route: "/catalog" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            hrSub: {
                text:
                    "Назначение доступов — в «Оценке» или в группе. Закупку квот оформляет главный HR.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            staff: {
                text:
                    "Доступы выдаёт HR. Если ждёте тест или курс — напишите руководителю; " +
                    "назначения появятся в «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "receive-quotas",
        priority: 19,
        matchAll: [
            ["как", "получ", "квот"],
            ["получ", "квот"],
            ["как", "мне", "получ", "квот"],
            ["где", "взять", "квот"],
            ["как", "достать", "квот"],
            ["как", "получить", "квот"],
        ],
        matchRegex: [/^как\s+(мне\s+)?получить\s+квот/],
        roles: {
            hrMain: {
                text:
                    "Квоты на тесты, курсы и тренажёры закупаются в «Каталоге решений» → заказ попадает в «Заказы». " +
                    "После оплаты квоты появятся на балансе компании — их можно назначить сотрудникам.",
                actions: [
                    { label: "Каталог", route: "/catalog" },
                    { label: "Заказы", route: "/my-orders" },
                    { label: "Моя компания", route: "/" },
                ],
            },
            hrSub: {
                text:
                    "Новые квоты закупает главный HR в «Каталоге». Вы можете смотреть статусы в «Заказы» " +
                    "и распределять уже выделенные квоты в своих группах.",
                actions: [
                    { label: "Заказы", route: "/my-orders" },
                    { label: "Группы", route: "/groups" },
                ],
            },
            staff: {
                text:
                    "Квоты и доступы закупает и назначает HR/руководитель. " +
                    "Вам не нужно получать квоты — дождитесь назначения в «Моё развитие».",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "start-work-short",
        priority: 19,
        matchAll: [
            ["как", "начать"],
            ["чем", "начать"],
            ["как", "работать", "кабинет"],
            ["с", "чего", "работ"],
            ["чеклист"],
            ["начало", "работ"],
            ["первый", "раз", "кабинет"],
            ["новичок", "кабинет"],
        ],
        matchRegex: [/^как\s+начать$/, /^с\s+чего\s+начать$/, /^чем\s+начать$/],
        roles: {
            hrMain: {
                text:
                    "С чего начать в кабинете (главный HR):\n\n" +
                    "1) «Моя компания» — обзор и доступы.\n" +
                    "2) «Сотрудники» — добавить команду.\n" +
                    "3) «Группы» — команды для массовых действий.\n" +
                    "4) «Каталог» → «Заказы» — квоты на тесты.\n" +
                    "5) «Оценка» — выдать тестирование.\n" +
                    "6) «Аналитика» — контроль и отчёты.\n\n" +
                    "Пошаговый чеклист — в «Начало работы».",
                actions: [
                    { label: "Чеклист старта", route: "/begin" },
                    { label: "Сотрудники", route: "/staff" },
                ],
            },
            hrSub: {
                text:
                    "С чего начать (HR подразделения):\n\n" +
                    "1) «Группы» — ваши команды.\n" +
                    "2) «Оценка» — выдача тестов и отчёты.\n" +
                    "3) «Развитие» — курсы.\n" +
                    "4) Квоты закупает главный HR.\n\n" +
                    "Чеклист — «Начало работы».",
                action: { label: "Чеклист старта", route: "/begin" },
            },
            staff: {
                text:
                    "С чего начать сотруднику:\n\n" +
                    "1) Дождитесь назначения от HR.\n" +
                    "2) «Моё развитие» — все назначения.\n" +
                    "3) Пройдите тест за 24 часа после начала.\n" +
                    "4) Отчёт — если HR разрешил просмотр.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "pass-assigned-test",
        priority: 18,
        matchAll: [
            ["как", "пройти", "тест"],
            ["где", "пройти", "тест"],
            ["начать", "тест"],
            ["продолж", "тест"],
            ["пройти", "тестирован"],
            ["где", "тестирован"],
            ["ссылк", "тест"],
            ["не", "могу", "начать", "тест"],
            ["как", "начать", "прохожден"],
            ["начать", "прохожден"],
            ["начать", "прохожд"],
            ["как", "начать", "прохожд"],
        ],
        matchRegex: [/^как\s+начать\s+прохожден/],
        roles: {
            hrMain: {
                text:
                    "Сотрудник проходит тест из «Моё развитие» или личного кабинета по ссылке. " +
                    "После начала — 24 часа на завершение. Статусы смотрите в «Оценке».",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Прохождение у сотрудника — из «Моё развитие». Статусы — в «Оценке» по вашим группам.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "Откройте «Моё развитие» → карточка теста → «Пройти». " +
                    "После начала завершите тест в течение 24 часов без перерыва.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "remind-testing",
        priority: 17,
        matchAll: [
            ["напомн", "сотрудник"],
            ["напомн", "прохожден"],
            ["напомн", "тест"],
            ["отправ", "напоминан"],
            ["уведом", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Напомнить о тесте: «Оценка» → выберите сотрудников с незавершённым прохождением → " +
                    "действие «Напомнить». Настройка шаблонов писем — «Уведомления → По тестам».",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Уведомления", route: "/notifications/tests" },
                ],
            },
            hrSub: {
                text: "В «Оценке» по своим группам — выбор строк → напоминание о прохождении.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "download-report-hr",
        priority: 17,
        matchAll: [
            ["скача", "отчет"],
            ["скач", "отчет"],
            ["получ", "отчет"],
            ["где", "отчет", "pdf"],
            ["выгруз", "отчет"],
            ["массов", "отчет"],
        ],
        roles: {
            hrMain: {
                text:
                    "Отчёты по тестированию — в «Оценке»: завершённые прохождения → скачать PDF по строке " +
                    "или массово по группе. Специальные сводные отчёты — «Аналитика → Отчёты».",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                ],
            },
            hrSub: {
                text: "PDF по команде — «Оценка». Аналитические сводки — «Аналитика → Отчёты».",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                ],
            },
            staff: {
                text:
                    "Ваш отчёт (если HR разрешил) — в «Моё развитие» или личном кабинете после завершения теста.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "report-visibility",
        priority: 16,
        matchAll: [
            ["видимост", "отчет"],
            ["показать", "отчет", "сотрудник"],
            ["выдать", "отчет", "сотрудник"],
            ["разреш", "отчет"],
            ["скрыть", "отчет"],
            ["настро", "видимост"],
        ],
        roles: {
            hrMain: {
                text:
                    "Видимость отчёта для сотрудника настраивается в «Оценке» — «Настроить видимость отчётов» " +
                    "или при выдаче теста (флаг «выдать отчёт после прохождения»).",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "То же в «Оценке» по сотрудникам ваших групп.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text: "Видимость отчёта включает HR. Если отчёта нет — попросите руководителя или HR.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "summary-table",
        priority: 16,
        matchAll: [
            ["сводн", "таблиц"],
            ["таблиц", "прохожден"],
            ["все", "прохожден"],
            ["детальн", "таблиц"],
            ["истечен", "дат"],
        ],
        roles: {
            hrMain: {
                text:
                    "Сводная таблица всех прохождений: «Оценка» → кнопка «Сводная таблица». " +
                    "Там же даты истечения и статусы по компании.",
                actions: [
                    { label: "Сводная таблица", route: "/detailed" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            hrSub: {
                text: "Сводная таблица — в «Оценке», кнопка «Сводная таблица» (по доступным группам).",
                actions: [
                    { label: "Сводная таблица", route: "/detailed" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "excel-import-staff",
        priority: 15,
        matchAll: [
            ["загруз", "excel"],
            ["импорт", "excel"],
            ["массов", "добав", "сотрудник"],
            ["шаблон", "excel"],
            ["загруз", "список"],
        ],
        roles: {
            hrMain: {
                text:
                    "Массовое добавление: «Сотрудники» → добавление → «Массовое добавление» → " +
                    "скачайте шаблон Excel, заполните и загрузите файл.",
                actions: [
                    { label: "Сотрудники", route: "/staff" },
                ],
            },
            hrSub: {
                text: "Массовая загрузка сотрудников доступна главному HR. Вы можете добавлять сотрудников вручную в своей зоне.",
                action: { label: "Сотрудники", route: "/staff" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "revoke-quota",
        priority: 15,
        matchAll: [
            ["отозв", "квот"],
            ["вернут", "квот"],
            ["отмен", "доступ"],
            ["забрать", "доступ"],
            ["отозв", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Квоту можно вернуть в пул только если сотрудник не начинал тест или курс. " +
                    "После начала теста отзыв недоступен — только напоминание о завершении.",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Отзыв до начала прохождения — в «Управлении доступами». После старта теста — нельзя.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "test-expired-rules",
        priority: 14,
        matchAll: [
            ["просроч"],
            ["истек", "тест"],
            ["24", "час"],
            ["сутк"],
            ["не", "успел", "тест"],
            ["аннулир"],
            ["перепрохожден"],
        ],
        roles: {
            hrMain: {
                text:
                    "После начала теста сотрудник должен завершить его за 24 часа, иначе результат аннулируется. " +
                    "Новую квоту выдавать не обязательно — можно напомнить о прохождении. " +
                    "Слишком быстрое (<15 мин) или долгое (>1 ч) прохождение может снизить достоверность.",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "Правило 24 часов после начала — для всех типов отчётов. Статус «Просрочен» виден в «Оценке».",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text:
                    "После начала теста завершите его в течение 24 часов. Если срок вышел — " +
                    "обратитесь к HR, вам напомнят о повторном прохождении.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
    {
        id: "where-begin-checklist",
        priority: 14,
        matchAll: [
            ["где", "чеклист"],
            ["где", "начало", "работ"],
            ["раздел", "начало"],
        ],
        roles: {
            hrMain: {
                text: "Пошаговый чеклист для HR — раздел «Начало работы».",
                action: { label: "Начало работы", route: "/begin" },
            },
            hrSub: {
                text: "Чеклист старта — «Начало работы».",
                action: { label: "Начало работы", route: "/begin" },
            },
            staff: {
                text: "Справка по кабинету для сотрудника — «Помощь с ЛК» и «Моё развитие».",
                actions: [
                    { label: "Помощь с ЛК", route: "/faq" },
                    { label: "Моё развитие", route: "/my-development" },
                ],
            },
        },
    },
    {
        id: "where-catalog-orders",
        priority: 13,
        matchAll: [
            ["где", "каталог"],
            ["где", "заказ"],
            ["где", "купить"],
            ["где", "закуп"],
        ],
        roles: {
            hrMain: {
                text: "Закупка — «Каталог решений», статусы заказов — «Заказы».",
                actions: [
                    { label: "Каталог", route: "/catalog" },
                    { label: "Заказы", route: "/my-orders" },
                ],
            },
            hrSub: {
                text: "Каталог для просмотра доступен; новый заказ оформляет главный HR. «Заказы» — статусы.",
                actions: [
                    { label: "Каталог", route: "/catalog" },
                    { label: "Заказы", route: "/my-orders" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "difference-rating-analytics",
        priority: 13,
        matchAll: [
            ["чем", "отлича", "оценк", "аналитик"],
            ["разниц", "оценк", "аналитик"],
            ["оценк", "или", "аналитик"],
            ["операцион", "аналитик"],
        ],
        roles: {
            hrMain: {
                text:
                    "«Оценка» — операционно: кому выдан тест, статусы, скачивание PDF, напоминания. " +
                    "«Аналитика» — сводные и спецотчёты (ЭИ-профиль, сравнение групп, динамика).",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Мониторинг", route: "/analytics/dashboard" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                ],
            },
            hrSub: {
                text: "«Оценка» — выдача и отчёты по команде. «Аналитика» — сводки и спецотчёты.",
                actions: [
                    { label: "Оценка", route: "/rating" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "assign-test-all",
        priority: 18,
        matchAll: [
            ["всем", "сотрудник"],
            ["все", "сотрудник", "тест"],
            ["всей", "компани", "тест"],
            ["массов", "тест"],
            ["всем", "тест"],
        ],
        roles: {
            hrMain: {
                text:
                    "Всем сотрудникам: «Группы» → группа «Все сотрудники» или нужная группа → " +
                    "выделить всех → «Управление доступами». Или «Оценка» с фильтром и массовым выбором.",
                actions: [
                    { label: "Группы", route: "/groups" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            hrSub: {
                text: "Массовая выдача — в обзоре вашей группы или в «Оценке» с выбором нескольких сотрудников.",
                actions: [
                    { label: "Группы", route: "/groups" },
                    { label: "Оценка", route: "/rating" },
                ],
            },
            staff: { text: NOT_AVAILABLE_MESSAGE, action: null },
        },
    },
    {
        id: "management-two-reports",
        priority: 12,
        matchAll: [
            ["два", "отчет"],
            ["управленческ", "два"],
            ["отчет", "сотрудник", "заказчик"],
            ["employer", "employee"],
        ],
        roles: {
            hrMain: {
                text:
                    "Управленческий потенциал даёт два PDF: для сотрудника и для заказчика (HR). " +
                    "Выдаётся через «Управление доступами» как тип «Управленческий».",
                action: { label: "Оценка", route: "/rating" },
            },
            hrSub: {
                text: "При выдаче выберите тип «Управленческий потенциал» — два файла после завершения.",
                action: { label: "Оценка", route: "/rating" },
            },
            staff: {
                text: "При управленческом типе вы получите свою версию отчёта, если HR включил видимость.",
                action: { label: "Моё развитие", route: "/my-development" },
            },
        },
    },
];
